import { actions } from "@grandvisionhq/state";
const selectLensType = actions.action(
  "products/prescription-glasses/select-lens-type",
  actions.payload()
);
const selectLensTypeFailed = actions.action(
  "products/prescription-glasses/select-lens-type-failed",
  actions.payload()
);
const selectLensTypeSuccess = actions.action(
  "products/prescription-glasses/select-lens-type-success",
  actions.payload()
);
const selectPackage = actions.action(
  "products/prescription-glasses/select-package",
  actions.payload()
);
const selectPackageFailed = actions.action(
  "products/prescription-glasses/select-package-failed",
  actions.payload()
);
const selectPackageSuccess = actions.action(
  "products/prescription-glasses/select-package-success",
  actions.payload()
);
const resetSelectedPackage = actions.action(
  "products/prescription-glasses/reset-selected-package",
  actions.payload()
);
const selectAddOn = actions.action(
  "products/prescription-glasses/select-add-on",
  actions.payload()
);
const selectAddOnFailed = actions.action(
  "products/prescription-glasses/select-add-on-failed",
  actions.payload()
);
const selectAddOnSuccess = actions.action(
  "products/prescription-glasses/select-add-on-success",
  actions.payload()
);
const resetSelectedAddOn = actions.action(
  "products/prescription-glasses/reset-selected-add-on",
  actions.payload()
);
const updateUploadReference = actions.action(
  "products/prescription-glasses/update-upload-reference",
  actions.payload()
);
const removeUploadReference = actions.action(
  "products/prescription-glasses/remove-upload-reference",
  actions.payload()
);
const updatePrescriptionValue = actions.action(
  "products/prescription-glasses/update-prescription-value",
  actions.payload()
);
const updatePrescriptionRecognitionValues = actions.action(
  "products/prescription-glasses/update-prescription-recognition-values",
  actions.payload()
);
const updatePrescriptionInfo = actions.action(
  "products/prescription-glasses/update-prescription-info",
  actions.payload()
);
const updatePrescriptionType = actions.action(
  "products/prescription-glasses/update-prescription-type",
  actions.payload()
);
const updateVerificationAllowed = actions.action(
  "products/prescription-glasses/update-verification-allowed",
  actions.payload()
);
export {
  removeUploadReference,
  resetSelectedAddOn,
  resetSelectedPackage,
  selectAddOn,
  selectAddOnFailed,
  selectAddOnSuccess,
  selectLensType,
  selectLensTypeFailed,
  selectLensTypeSuccess,
  selectPackage,
  selectPackageFailed,
  selectPackageSuccess,
  updatePrescriptionInfo,
  updatePrescriptionRecognitionValues,
  updatePrescriptionType,
  updatePrescriptionValue,
  updateUploadReference,
  updateVerificationAllowed
};
//# sourceMappingURL=actions.js.map
